import { z } from 'zod'

export const systemVersionSchema = z.object({
  /** 版本號 */
  version: z.string()
})

export interface SystemVersion extends z.infer<typeof systemVersionSchema> {}
